const STORAGE_KEY = 'zhima_sand_session'

/** 班级列表项对应的存档 slot（与列表顺序一致） */
export function getClassSlotKey (item, index) {
  if (item && item.slot != null && item.slot !== '') {
    return String(item.slot)
  }
  return String((index != null ? index : 0) + 1)
}

export function saveSandSession (payload) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  } catch (e) {
    /* ignore quota errors */
  }
}

export function getSandSession () {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/sandSession.js